// ignore-string-externalization

import React from 'react';
import { LoggedInRedirect } from '../features/Auth';
import { Wait } from '../features/Layout';
import { getServerSidePropsWithRootRedirect } from '../features/RootRedirect';

type Props = {
  // injected by the _app component
  activeSession?: boolean;
};

export const getServerSideProps = getServerSidePropsWithRootRedirect(
  async ({ req }) => {
    const url = req.url || '';
    const loggedOut = !('sp_dc' in req.cookies); // user is logged out if sso cookie is missing
    const hasQuery = /\?.+$/.test(url); // url has query string
    let queries = '';
    if (hasQuery) {
      queries = url.substring(url.indexOf('?'));
    }
    // redirect if user is logged out or has query string
    if (loggedOut || hasQuery) {
      return {
        redirect: {
          destination: `/home${queries}`,
          permanent: false,
        },
      };
    }

    // if logged in then render the index page to dynamically check if
    // user has access before redirecting to dashboard or /home
    return {
      props: {},
    };
  },
);

export default function HomePage({ activeSession = false }: Props) {
  return (
    <LoggedInRedirect activeSession={activeSession}>
      <Wait cover />
    </LoggedInRedirect>
  );
}
